import * as React from 'react';
import Typography from '@mui/material/Typography';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import {useEffect} from "react";
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import authService from './api-authorization/AuthorizeService'
import moment from 'moment';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
export default function VideoDetailsCard({
                                             open,
                                             handleOpenDialog,
                                             handleCloseDialog,
                                             columns,
                                             row,
                                                channelId,
                                             active
                                         }) {

    const [loading, setLoading] = React.useState(false);
    const [ video, setVideo] = React.useState(row);
    const [urlDetailsOpen, setUrlDetailsOpen] = React.useState(false);
    const [urlDetailsLoading, setUrlDetailsLoading] = React.useState(false);
    const [urlDetailsPending, setUrlDetailsPending] = React.useState(false);
    const [currentUrlDetails, setCurrentUrlDetails] = React.useState({brands: [], aff_urls_dest_page: [], aff_urls_in_redirects: [], request: { Parameters: { Url: "" } }});
    const [currentUrlId, setCurrentUrlId] = React.useState(null);
    const [currentUrlLinks, setCurrentUrlLinks] = React.useState([]);
    const [redirects, setRedirects] = React.useState([]);
    const [downloadAvailable, setDownloadAvailable] = React.useState(false);

    useEffect(() => {
        
        if(row && row.id) {
            // declare the async data fetching function
            setVideo(row);


            const fetchData = async () => {
                setLoading(true);
                //const token = await authService.getAccessToken();
                const response = await fetch(`/api/channels/details/${channelId}/video/` + row.id, {
                    //headers: !token ? {} : {'Authorization': `Bearer ${token}`}
                });
                authService.followIfLoginRedirect(response);
                const data = await response.json();
                setVideo(data);
                //console.log("video detais loads");
                setLoading(false);
            }

            // call the function
            fetchData()
                // make sure to catch any error
                .catch(console.error);
            ;
        }
    }, [row,channelId])
    const handleClose = () => {
        handleCloseDialog();
    };
    const handleClickOpen = () => {
        handleOpenDialog();
    };

    const openUrlDetails = async (urlId) => {
        setCurrentUrlId(urlId);
        setUrlDetailsLoading(true);
        setUrlDetailsPending(false);
        setCurrentUrlLinks([]);
        setRedirects([]);
        setDownloadAvailable(false);
        try {
            const response = await fetch(`/api/channels/${channelId}/details/url/${urlId}/details`, {
                method: "GET"
            });
            authService.followIfLoginRedirect(response);
            if (response.status === 202) {
                setUrlDetailsPending(true);
                setUrlDetailsOpen(true);
                return;
            }
            if (!response.ok) {
                throw new Error(`URL details failed (${response.status})`);
            }
            const data = await response.json();
            setCurrentUrlDetails(data);
            const objectives = data?.request?.Objectives || [];

            const screenshotObjective = objectives.find((x) => x.Type === "screenshot");
            if (screenshotObjective) {
                setDownloadAvailable(true);
            }

            const linkObjective = objectives.find((x) => x.Type === "links");
            if (linkObjective?.Result?.Links) {
                setCurrentUrlLinks(linkObjective.Result.Links);
            }

            const redirectObjective = objectives.find((x) => x.Type === "redirect");
            if (redirectObjective?.Result?.Urls) {
                setRedirects(redirectObjective.Result.Urls);
            }

            setUrlDetailsOpen(true);
        } catch (e) {
            setUrlDetailsPending(true);
            setUrlDetailsOpen(true);
        } finally {
            setUrlDetailsLoading(false);
        }
    };

    const downloadScreenshot = async () => {
        if (!currentUrlId) {
            return;
        }
        try {
            const response = await fetch(`/api/channels/${channelId}/details/url/${currentUrlId}/file`, {
                method: "GET"
            });
            authService.followIfLoginRedirect(response);
            if (!response.ok) {
                throw new Error(`Screenshot download failed (${response.status})`);
            }
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = `url-screenshot-${currentUrlId}.jpg`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (e) {
            // keep silent to avoid interrupting the main flow
        }
    };
    return (
        <>
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth
        >
            
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {video.video_title}
                    </Typography>
                    
                </Toolbar>
            </AppBar>
            <DialogContent dividers>
                {loading && (
                    <Box sx={{display: "flex", justifyContent: "center", py: 3}}>
                        <CircularProgress size={26} />
                    </Box>
                )}

                {!loading && (
                    <Box>
                        <Grid container spacing={1} sx={{mb: 1}}>
                            <Grid item>
                                <Chip size="small" label={`Video ID: ${video.video_id || "n/a"}`} />
                            </Grid>
                            {video.views !== undefined && (
                                <Grid item>
                                    <Chip size="small" label={`${(video.views || 0).toLocaleString()} views`} />
                                </Grid>
                            )}
                            {video.duration !== undefined && (
                                <Grid item>
                                    <Chip size="small" label={`Duration: ${video.duration || 0}s`} />
                                </Grid>
                            )}
                        </Grid>

                        <Grid container spacing={2} sx={{mb: 1}}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Discovered</Typography>
                                <Typography color="text.secondary">
                                    {video.date_received ? moment(video.date_received).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Last Updated</Typography>
                                <Typography color="text.secondary">
                                    {video.last_updated ? moment(video.last_updated).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Published</Typography>
                                <Typography color="text.secondary">
                                    {video.date_published ? moment(video.date_published).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Processed</Typography>
                                <Typography color="text.secondary">
                                    {video.video_analysis_complete ? moment(video.video_analysis_complete).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Downloaded</Typography>
                                <Typography color="text.secondary">
                                    {video.date_downloaded ? moment(video.date_downloaded).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Processing Attempt</Typography>
                                <Typography color="text.secondary">
                                    {video.processing_last_attempted ? moment(video.processing_last_attempted).format("dddd, MMMM Do YYYY, h:mm:ss a") : "n/a"}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{my: 2}} />

                        <Typography variant="h6" sx={{mb: 1}}>Description</Typography>
                        <Typography variant="body2" sx={{whiteSpace: "pre-wrap"}}>
                            {video.video_description || "No description"}
                        </Typography>

                        <Box sx={{mt: 2}}>
                            <Typography variant="h6" sx={{mb: 1}}>URLs ({video.urls?.length || 0})</Typography>
                            {(video.urls || []).length === 0 && (
                                <Typography color="text.secondary">No URLs detected.</Typography>
                            )}
                            {(video.urls || []).slice(0, 8).map((u) => (
                                <Paper key={u.id} sx={{p: 1.25, mb: 1, border: "1px solid #eee"}}>
                                    <Link href={u.url} target="_blank" rel="noreferrer" underline="hover">{u.url}</Link>
                                    <Box sx={{mt: 1}}>
                                        {(u.is_aff_link || u.aff_link_on_dest || u.aff_link_in_redirects || !!u.affiliate_url) && (
                                            <MonetizationOnIcon color="success" fontSize="small" sx={{mr: 1, verticalAlign: "middle"}} />
                                        )}
                                        <Button size="small" variant="outlined" onClick={() => openUrlDetails(u.id)}>
                                            Details
                                        </Button>
                                    </Box>
                                    {(u.brands || []).length > 0 && (
                                        <Box sx={{mt: 1, display: "flex", flexWrap: "wrap", gap: 0.75}}>
                                            {u.brands.map((b) => (
                                                <Chip key={`${u.id}-${b.id}`} size="small" label={b.organisation_brand?.name || b.domain} />
                                            ))}
                                        </Box>
                                    )}
                                </Paper>
                            ))}
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Typography variant="h6" sx={{mb: 1}}>
                                Screenshots ({video.screenshots?.length || 0})
                            </Typography>
                            {(video.screenshots || []).length === 0 && (
                                <Typography color="text.secondary">No screenshots available.</Typography>
                            )}
                            <Grid container spacing={1.5}>
                                {(video.screenshots || []).slice(0, 12).map((s) => (
                                    <Grid item xs={6} md={3} key={s.id}>
                                        <Paper sx={{p: 1, border: "1px solid #eee"}}>
                                            <Box
                                                component="img"
                                                alt={`Screenshot ${s.id}`}
                                                src={`/api/projects/details/match/screenshot/${s.id}`}
                                                sx={{width: "100%", height: 120, objectFit: "cover", borderRadius: 1, mb: 0.75}}
                                            />
                                            <Typography sx={{fontSize: 12, color: "#666"}}>
                                                {s.seconds}s
                                            </Typography>
                                            <Box sx={{display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5}}>
                                                {(s.labels || []).slice(0, 3).map((l, idx) => (
                                                    <Chip
                                                        key={`${s.id}-${idx}-${l.label}`}
                                                        size="small"
                                                        label={`${l.label} ${Math.round((l.score || 0) * 100)}%`}
                                                    />
                                                ))}
                                            </Box>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>
                )}
            </DialogContent>
        </Dialog>

        <Dialog
            open={urlDetailsOpen}
            onClose={() => setUrlDetailsOpen(false)}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>URL Details</DialogTitle>
            <DialogContent dividers>
                {urlDetailsLoading && (
                    <Box sx={{display: "flex", justifyContent: "center", py: 3}}>
                        <CircularProgress size={24} />
                    </Box>
                )}
                {!urlDetailsLoading && urlDetailsPending && (
                    <DialogContentText>
                        This URL has not yet been analysed, or details are not available yet.
                    </DialogContentText>
                )}
                {!urlDetailsLoading && !urlDetailsPending && (
                    <Box>
                        <Typography gutterBottom>
                            <strong>URL:</strong> {currentUrlDetails?.request?.Parameters?.Url || "n/a"}
                        </Typography>
                        <Typography gutterBottom>
                            <strong>Date Analysed:</strong> {currentUrlDetails?.request?.DateGenerated ? moment(currentUrlDetails.request.DateGenerated).format("DD MMM YYYY HH:mm") : "n/a"}
                        </Typography>
                        <Typography gutterBottom>
                            <strong>Response Status:</strong> {currentUrlDetails?.request?.ResponseStatus ?? "n/a"}
                        </Typography>
                        {(currentUrlDetails?.request?.ResponseStatus === 0) && (
                            <Alert severity="error" sx={{mb: 1}}>
                                Could not reach the URL when analysis was attempted.
                            </Alert>
                        )}
                        {(currentUrlDetails?.request?.ResponseStatus === 300 || currentUrlDetails?.request?.ResponseStatus === 301) && (
                            <Alert severity="warning" sx={{mb: 1}}>
                                This URL redirects to another destination.
                            </Alert>
                        )}

                        <Box sx={{mt: 1.5}}>
                            <Typography variant="subtitle2">Redirect chain</Typography>
                            <Box sx={{mt: 0.5}}>
                                {redirects.length > 0
                                    ? redirects.map((u, idx) => (
                                        <Typography key={`rc-${idx}`} sx={{fontSize: 13, mb: 0.25}}>{u}</Typography>
                                    ))
                                    : <Typography color="text.secondary">No redirects detected.</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Typography variant="subtitle2">Links on page ({currentUrlLinks.length})</Typography>
                            <Box sx={{mt: 0.5, maxHeight: 180, overflow: "auto", border: "1px solid #eee", borderRadius: 1, p: 1}}>
                                {currentUrlLinks.length > 0
                                    ? currentUrlLinks.slice(0, 200).map((u, idx) => (
                                        <Typography key={`lp-${idx}`} sx={{fontSize: 13, mb: 0.25}}>{u}</Typography>
                                    ))
                                    : <Typography color="text.secondary">No links captured.</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Typography variant="subtitle2">Brands detected</Typography>
                            <Box sx={{display: "flex", flexWrap: "wrap", gap: 0.75, mt: 0.5}}>
                                {(currentUrlDetails?.brands || []).length > 0
                                    ? currentUrlDetails.brands.map((b) => (
                                        <Chip key={`${b.id}-${b.domain}`} size="small" label={b.organisation_brand?.name || b.domain} />
                                    ))
                                    : <Typography color="text.secondary">No brand links detected.</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Typography variant="subtitle2">Affiliate URLs on destination page</Typography>
                            <Box sx={{mt: 0.5}}>
                                {(currentUrlDetails?.aff_urls_dest_page || []).length > 0
                                    ? (currentUrlDetails.aff_urls_dest_page || []).slice(0, 50).map((v, idx) => (
                                        <Typography key={`dest-${idx}`} sx={{fontSize: 13, mb: 0.25}}>{v}</Typography>
                                    ))
                                    : <Typography color="text.secondary">None found.</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{mt: 2}}>
                            <Typography variant="subtitle2">Affiliate URLs in redirects</Typography>
                            <Box sx={{mt: 0.5}}>
                                {(currentUrlDetails?.aff_urls_in_redirects || []).length > 0
                                    ? (currentUrlDetails.aff_urls_in_redirects || []).slice(0, 50).map((v, idx) => (
                                        <Typography key={`redir-${idx}`} sx={{fontSize: 13, mb: 0.25}}>{v}</Typography>
                                    ))
                                    : <Typography color="text.secondary">None found.</Typography>}
                            </Box>
                        </Box>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                {downloadAvailable && (
                    <Button variant="outlined" color="success" onClick={downloadScreenshot}>
                        Download Screenshot
                    </Button>
                )}
                <Button onClick={() => setUrlDetailsOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
        </>
    );
}
